<template>
    <div class="inner">

      <home-cover :home-list-length="dataList.length"/>
      <template v-if="this.$isCustomization()">
        <home-recommend-monpay :data-list="dataList" v-if="this.$isMonPay()"/>
        <home-recommend-oppo :trace="trace" :data-list="dataList" v-if="this.$isOppo()"/>
        <home-recommend-toki :data-list="dataList" v-if="this.$isToki()"></home-recommend-toki>
      </template>
      <home-recommend :data-list="dataList" v-if="!this.$isCustomization()"/>


    </div>
</template>

<script>
import MiniStore from "@/api/mini-store";
import HomeCover from "@/views/home/components/home-cover";
import HomeRecommend from "./components/home-recommend";
import HomeRecommendOppo from "./components/home-recommend-oppo";
import HomeRecommendMonpay from "./components/home-recommend-monpay";
import Oppo from "@/api/oppo";
import HomeRecommendToki from "@/views/home/components/home-recommend-toki";

export default{
  name: "HomePage",
  components: {
    HomeRecommendToki,
    HomeRecommendMonpay,
    HomeRecommendOppo,
    HomeCover,
    HomeRecommend
  },
  data() {
    return {
      trace: {
        inTime: '',
        outTime: '',
        pre_page_num: '',
        page_num: Oppo.PAGE_NUM_HOME_PAGE,
        pkg_name: ''
      },
      page: {
        current_page: 1,
        page_size: 50,
        total_pages: 0,
        total_items: 0,
        expo_dur:0
      },
      dataList: []
    }
  },
  created() {
    this.getCategories()
  },
  activated() {
    this.trace.inTime = (new Date()).getTime()
    Oppo.trackPageEntrance(this.trace)
  },
  deactivated() {
    this.trace.outTime = (new Date()).getTime()
    this.trace.expo_dur = parseInt((this.trace.outTime - this.trace.inTime) / 1000)
    Oppo.trackPageExit(this.trace)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.meta && from.meta.oppo_page_id) {
        vm.trace.pre_page_num = from.meta.oppo_page_id
      }
    })
  },
  methods: {
      productUrl(category) {
        if (category.mode === 'pin') {
          return '/card/' + category.code
        }
        if (category.mode === 'directtopup') {
          return '/direct-top-up/' + category.code
        }
        return '/'
      },
      getCategories() {
        this.$loading(true)
        // monpay 查询20个
        if (this.$isMonPay()) {
          this.page.page_size = 20
        }
        MiniStore.getCategories(this.page).then(res => {
          if (res.errcode === 200) {
            this.page.current_page = res.data.page.current_page
            this.page.page_size = res.data.page.page_size
            this.page.total_pages = res.data.page.total_pages
            this.page.total_items = res.data.page.total_items
            this.dataList = this.dataList.concat(res.data.list)
          }
          this.$loading(false)
        }).catch(e => {
          this.$loading(false)
        })
      }
    }
	}
</script>

<style>
</style>
